import environment from '../../environments';

export interface HazardEntityConfig {
  name?: string;
  idPrefix?: string;
}

export interface HazardConfig {
  cause?: HazardEntityConfig;
  control?: HazardEntityConfig;
  action?: HazardEntityConfig;
}

export const getHazardEntityName = (key: keyof HazardConfig) => {
  switch (key) {
    case 'cause':
      return environment.hazardConfig?.cause || 'Cause';
    case 'control':
      return environment.hazardConfig?.control || 'Control';
    case 'action':
      return environment.hazardConfig?.action || 'Action';
    default:
      return '';
  }
};

export const getHazardIdPrefix = () => {
  return environment.hazardConfig?.idPrefix || 'HAZARD';
};
